import { noop } from 'lodash'
import React, { createContext, useContext } from 'react'

const DEFAULT_STATE: {
  completed: string[]
  dispatch: React.Dispatch<{ id: string; type: string }>
} = {
  completed: [],
  dispatch: noop
}
export const UnitTransfersContext = createContext(DEFAULT_STATE)
export const useUnitTransfersContext = () => useContext(UnitTransfersContext)
